import { render, staticRenderFns } from "./StudentDetailUpdates.vue?vue&type=template&id=d4ed36ea&scoped=true&"
import script from "./StudentDetailUpdates.vue?vue&type=script&lang=js&"
export * from "./StudentDetailUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ed36ea",
  null
  
)

export default component.exports